import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, reduxForm } from 'redux-form/immutable';

import BasicForm from './BasicForm';
import Input from '../common/Input';
import SelectBox from '../common/SelectBox';
import DatePickerInput from '../common/DatePickerInput';
import Titles from '../title/Titles';
import * as constraints from '../../utils/constraints';

const DirectorForm = ({ handleSubmit, submitting, cycles }) => (
  <form onSubmit={handleSubmit}>
    <BasicForm submitting={submitting}>
      <div>
        <Field
          name="graduationDate"
          label="Fecha de recibido"
          showYearDropdown
          placeholder="DD/MM/AAAA"
          component={DatePickerInput}
        />
      </div>
      <div>
        <Field
          name="yearsOfExperience"
          label="Años de experiencia"
          type="number"
          component={Input}
        />
      </div>
      <Field
        name="cycleId"
        label="Ciclo"
        options={cycles}
        placeholder="Seleccione un ciclo"
        component={SelectBox}
      />
      <FieldArray
        name="titlesAttributes"
        component={Titles}
      />
    </BasicForm>
  </form>
);

const { func, bool, array } = PropTypes;

DirectorForm.propTypes = {
  handleSubmit: func.isRequired,
  submitting: bool,
  cycles: array
};

export default reduxForm({
  form: 'signUp',
  validate: constraints.validations(constraints.director)
})(DirectorForm);



// WEBPACK FOOTER //
// ./src/components/user/DirectorForm.js